import moment from "moment";
import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { queryDateFormat } from "../../../config/constants";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import { handleErrors } from "../../services/handleErrors";
import { fetchTaskCategories, patchTask } from "../../services/taskServices";
import { taskUtil } from "../../utils/taskUtil";

const TaskListTable = ({ tasks, novedades, handleClickTask, withPaging, newTaskUpdated, withClientData }) => {
  const { currentUser } = useAuth();
  // const isAdmin = currentUser && currentUser.haveAdminAccess(modulos.CALENDAR);
  const orderedTasks = tasks && tasks.sort((a, b) => moment(a.dueDate) - moment(b.dueDate));

  const nextToCompleteIndex = orderedTasks && orderedTasks.findIndex((task) => task.completeDate === null);
  const today = moment().format(queryDateFormat);
  const [currentPage, setCurrentPage] = useState();
  const [categories] = useFetcher(fetchTaskCategories);
  const taskTypes = categories.type;

  const getNovedad = (tarea) => {
    return novedades && novedades.find((novedad) => novedad.id === tarea.novedadId);
  };
  const getTaskTypeStr = (typeId) => {
    const { text } = taskTypes.find((task) => task.id === typeId);
    return text;
  };

  const handleTogleCheck = async (taskId) => {
    try {
      const orderedTasksNew = [...tasks];
      const taskToUpdate = orderedTasksNew.find((el) => el.id === taskId);
      if (taskToUpdate.completeDate) {
        const { isConfirmed } = await SweetAlert.fire({
          title: `¿Esta seguro de rechazar la tarea?`,
          text: "Una vez rechazada, se le enviará una notificación al responsable",
          icon: "warning",
          confirmButtonColor: "#bf0d3e",
          showCancelButton: true,
          showConfirmButton: true,
        });

        if (isConfirmed) {
          taskToUpdate.completeDate = null;
          const { message, result } = await patchTask(taskToUpdate.novedadId, taskToUpdate);
          if (result.id) {
            newTaskUpdated(result);
            toast.success(message);
          } else {
            toast.warning(message);
          }
        }
      } else {
        taskToUpdate.completeDate = today;
        const { message, result } = await patchTask(taskToUpdate.novedadId, taskToUpdate);
        if (result.id) {
          newTaskUpdated(result);
          toast.success(message);
        } else {
          toast.warning(message);
        }
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  return (
    <div className="table-responsive support-table" style={{ marginTop: !withClientData ? "45px" : "" }}>
      {withPaging ? (
        <DataTable
          data={tasks}
          title={withClientData ? "Tareas" : null}
          paginationComponentOptions={{ rowsPerPageText: "Tareas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todas" }}
          paginationDefaultPage={currentPage}
          onChangePage={(page) => setCurrentPage(page)}
          noDataComponent={
            <div className="p-3">
              <b>No se encontraron tareas</b>
            </div>
          }
          striped
          pagination
          columns={
            !withClientData
              ? [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (tarea) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickTask(tarea)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                  },
                  {
                    name: "Responsable",
                    selector: (tarea) => tarea.responsable && tarea.responsable.nombreApellido,

                    center: true,
                    wrap: true,
                    id: "responsable",
                  },
                  {
                    name: "Tipo",
                    selector: (tarea) => taskTypes && getTaskTypeStr(tarea.type),

                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Vencimiento",
                    selector: (tarea) => moment(tarea.dueDate).format(queryDateFormat),

                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (tarea) => (tarea.completeDate ? moment(tarea.completeDate).format(queryDateFormat) : "-"),

                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (tarea) => taskUtil(tarea).statusHtml(),
                    sortFunction: (tarea) => taskUtil(tarea).statusStr(),

                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    selector: (tarea, i) => (
                      <span className="task-action-btn">{taskUtil(tarea).statusCheck(handleTogleCheck, currentUser, orderedTasks, i, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
              : [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (tarea) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickTask(tarea)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                    style: {
                      cursor: "pointer",
                    },
                    width: "90px",
                  },
                  {
                    name: "Subcliente",
                    // eslint-disable-next-line radix
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0),

                    center: true,
                    id: "subcliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Cliente",
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.razonSocial,

                    center: true,
                    wrap: true,
                    id: "cliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                    width: "200px",
                  },
                  {
                    name: "Sucursal",
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).sucursal.titulo,

                    center: true,
                    wrap: true,
                    id: "sucursal",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Responsable",
                    selector: (tarea) => tarea.responsable && tarea.responsable.nombreApellido,

                    center: true,
                    wrap: true,
                    id: "responsable",
                  },
                  {
                    name: "Tipo",
                    selector: (tarea) => taskTypes && getTaskTypeStr(tarea.type),

                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Vencimiento",
                    selector: (tarea) => moment(tarea.dueDate).format(queryDateFormat),

                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (tarea) => (tarea.completeDate ? moment(tarea.completeDate).format(queryDateFormat) : "-"),

                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (tarea) => taskUtil(tarea).statusHtml(),
                    sortFunction: (tarea) => taskUtil(tarea).statusStr(),

                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    selector: (tarea, i) => (
                      <span className="task-action-btn">{taskUtil(tarea).statusCheck(handleTogleCheck, currentUser, orderedTasks, i, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
          }
        />
      ) : (
        <DataTable
          data={tasks}
          title="Tareas"
          paginationComponentOptions={{ rowsPerPageText: "Tareas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todas" }}
          paginationDefaultPage={currentPage}
          onChangePage={(page) => setCurrentPage(page)}
          noDataComponent={
            <div className="p-3">
              <b>No se encontraron tareas</b>
            </div>
          }
          striped
          pagination
          columns={
            !withClientData
              ? [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (tarea) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickTask(tarea)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                  },
                  {
                    name: "Responsable",
                    selector: (tarea) => tarea.responsable && tarea.responsable.nombreApellido,

                    center: true,
                    wrap: true,
                    id: "responsable",
                  },
                  {
                    name: "Tipo",
                    selector: (tarea) => taskTypes && getTaskTypeStr(tarea.type),

                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Vencimiento",
                    selector: (tarea) => moment(tarea.dueDate).format(queryDateFormat),

                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (tarea) => (tarea.completeDate ? moment(tarea.completeDate).format(queryDateFormat) : "-"),

                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (tarea) => taskUtil(tarea).statusHtml(),
                    sortFunction: (tarea) => taskUtil(tarea).statusStr(),

                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    selector: (tarea, i) => (
                      <span className="task-action-btn">{taskUtil(tarea).statusCheck(handleTogleCheck, currentUser, orderedTasks, i, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
              : [
                  {
                    name: "#",
                    // eslint-disable-next-line radix
                    selector: (tarea) => (
                      <button className="btn btn-link" type="button" onClick={() => handleClickTask(tarea)}>
                        Ver
                      </button>
                    ),
                    sortable: false,
                    center: true,
                    id: "link",
                    style: {
                      cursor: "pointer",
                    },
                    width: "90px",
                  },
                  {
                    name: "Subcliente",
                    // eslint-disable-next-line radix
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0),

                    center: true,
                    id: "subcliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Cliente",
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.razonSocial,

                    center: true,
                    wrap: true,
                    id: "cliente",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                    width: "200px",
                  },
                  {
                    name: "Sucursal",
                    selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).sucursal.titulo,

                    center: true,
                    wrap: true,
                    id: "sucursal",
                    style: {
                      cursor: "pointer",
                      textAlign: "center",
                    },
                  },
                  {
                    name: "Responsable",
                    selector: (tarea) => tarea.responsable && tarea.responsable.nombreApellido,

                    center: true,
                    wrap: true,
                    id: "responsable",
                  },
                  {
                    name: "Tipo",
                    selector: (tarea) => taskTypes && getTaskTypeStr(tarea.type),

                    center: true,
                    wrap: true,
                    id: "tipo",
                  },
                  {
                    name: "Vencimiento",
                    selector: (tarea) => moment(tarea.dueDate).format(queryDateFormat),

                    center: true,
                    wrap: true,
                    id: "vencimiento",
                  },
                  {
                    name: "Resolución",
                    selector: (tarea) => (tarea.completeDate ? moment(tarea.completeDate).format(queryDateFormat) : "-"),

                    center: true,
                    wrap: true,
                    id: "resolucion",
                  },
                  {
                    name: "Estado",
                    selector: (tarea) => taskUtil(tarea).statusHtml(),
                    sortFunction: (tarea) => taskUtil(tarea).statusStr(),

                    center: true,
                    id: "estado",
                  },
                  {
                    name: " ",
                    selector: (tarea, i) => (
                      <span className="task-action-btn">{taskUtil(tarea).statusCheck(handleTogleCheck, currentUser, orderedTasks, i, nextToCompleteIndex)}</span>
                    ),
                    center: true,
                    id: "check",
                  },
                ]
          }
        />
      )}
    </div>
  );
};

export default TaskListTable;
